import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

const TeamWorkloadChart = ({ team_tickets }: any) => {

  const labels = team_tickets?.map((member: any) => member?.member_name);
  const ticketCounts = team_tickets?.map((member: any) => member?.ticket_count);

  const data = {
    labels,
    datasets: [
      {
        data: ticketCounts,
        backgroundColor: ["#FBBF24", "#3B82F6", "#EC4899", "#10B981", "#6366F1"],
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
  };

  return (
    <div className="p-4 border border-border rounded-lg shadow-md">
      <div className="w-full">
        <h3 className="text-lg font-semibold mb-4">Team Workload</h3>
        <div className="flex flex-col md:flex-row items-start md:items-center h-72">
          {/* Pie Chart */}
          <div className="flex-shrink-0 w-full md:w-1/2">
            <Pie className="h-200" data={data} options={options} />
          </div>
          <div
            className="mt-4 md:mt-0 md:ml-6 overflow-y-auto"
            style={{ maxHeight: '200px' }}
          >
            {data?.labels?.map((label: any, index: any) => (
              <div key={index} className="flex items-center mb-2 gap-2 mr-4">
                <span
                  className="w-4 h-4 inline-block mr-2 rounded-sm"
                  style={{ backgroundColor: data.datasets[0]?.backgroundColor[index] }}
                ></span>
                <span className="text-sm font-medium flex-1">{label}</span>
                <span className="text-sm font-semibold">
                  {data?.datasets[0].data[index]}
                </span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default TeamWorkloadChart;

